import { TextField, Tooltip } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { Autocomplete, Pagination } from "@material-ui/lab";
import synchronizeApi from "api/synchronizeApi";
import cn from "classnames";
import ButtonComponent from "components/Button";
import Flex from "components/Flex";
import CustomDateRangePicker from "components/Form/CommonDatePicker";
import CommonModal from "components/Form/CommonModal";
import Loading from "components/Loading";
import _ from "lodash";
import { useEffect, useRef, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { openToast } from "stores/toast/slice.toast";
import * as actionsFanpage from "views/Fanpage/FanpageActions";
import { fanpageFull } from "views/Fanpage/FanpageSelectors";
import Checkbox from "../../../components/Form/Checkbox";
import SingleSelectbox from "../../../components/Form/Selectbox/SingleSelectbox";
import types from "../../../constants/types";
import MainLayout from "../../MainLayout";
import moment from "moment";
import SyncChart from "./SyncChart";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "no-repeat top",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // minHeight: "100vh",
    backgroundSize: "cover",
    paddingTop: "20px",
    paddingBottom: "20px"
  },
  container: {
    width: "100%",
    margin: "0 auto",
    // height: "100vh"
  },
  syn_info_user: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    width: "100%",
    margin: "0 auto",
    marginTop: "12px",
    marginBottom: "40px"
  },
  syn_history: {
    width: "100%",
    margin: "0 auto",
    marginTop: "12px",
    marginBottom: "12px"
  },
  formControl: {
    minWidth: 120
  },
  checkboxGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "20px"
  },

  table: {
    minWidth: "100%"
  },
  tableHead: {
    backgroundColor: "#F4F4F4FF"
  },
  tableCell: {
    padding: "12px 16px",
    minWidth: "150px"
  },
  witdhOrd: {
    minWidth: "80px",
    padding: "0 8px !important",
    whiteSpace: "nowrap",
    height: "52px"
  },
  f600: {
    fontWeight: 600
  },
  tableHeadCell: {
    fontWeight: "bold",
    height: "52px !important",
    "&:hover": {
      color: "black"
    }
  },
  helpButton: {
    cursor: "pointer",
    border: "none",
    outline: "none",
    borderRadius: "12px",
    background: "none",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "rgba(204, 204, 204, 0.3)",
      borderRadius: "12px"
    }
  },
  title: {
    padding: "8px",
    fontSize: "14px",
    height: "42px",
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
    whiteSpace: "nowrap"
  },
  buttonSelectPeriodTime: {
    marginLeft: "8px",
    borderRadius: "12px",
    color: "white",
    fontSize: "14px",
    padding: "8px 16px",
    cursor: "pointer",
    transition: "background-color 0.3s, border-color 0.3s",
    border: "2px solid",
    borderColor: "#02a351",
    backgroundColor: "#02a351",
    "&:hover": {
      backgroundColor: "#02a351",
      borderColor: "#4ED1A0"
    }
  },
  sortIcon: {
    marginLeft: theme.spacing(1),
    transition: "opacity 0.3s",
    "&:hover": {
      opacity: 0.7,
      color: "black"
    }
  },
  clearButton: {
    cursor: "pointer",
    border: "none",
    outline: "none",
    marginLeft: "4px",
    padding: "8px",
    borderRadius: "12px",
    background: "none",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "rgba(204, 204, 204, 0.3)",
      borderRadius: "12px"
    }
  }
}));

function EnhancedTableHead(props) {
  const { classes, t, onSortChange, sortOrder } = props;

  const headCells = [
    {
      id: "ord_number",
      numeric: true,
      disablePadding: true,
      label: t("synchronize_management.ord_number")
    },
    {
      id: "sync_time",
      numeric: false,
      disablePadding: true,
      label: t("synchronize_management.sync_time"),
      sortable: true
    },
    {
      id: "total_customers",
      numeric: false,
      disablePadding: true,
      label: t("synchronize_management.total_customers")
    },
    {
      id: "start_time",
      numeric: true,
      disablePadding: true,
      label: t("synchronize_management.start_time")
    },
    {
      id: "end_time",
      numeric: true,
      disablePadding: true,
      label: t("synchronize_management.end_time")
    },
    {
      id: "username",
      numeric: false,
      disablePadding: true,
      label: t("synchronize_management.username")
    },
    {
      id: "sync_type",
      numeric: false,
      disablePadding: true,
      label: t("synchronize_management.type")
    },
    {
      id: "completion_time",
      numeric: false,
      disablePadding: true,
      label: t("synchronize_management.completion_time")
    }
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            className={(classes.tableHeadCell, classes.sortIcon)}
          >
            {headCell.sortable ? (
              <TableSortLabel
                hideSortIcon
                onClick={() => onSortChange(headCell.id)}
              >
                {t(headCell.label)}
                {headCell.id === "sync_time" && (
                  <span className={classes.sortIcon}>
                    {sortOrder === "desc" ? (
                      <img src="/icon/Sort_Descending.svg" alt="Sort Desc" />
                    ) : (
                      <img src="/icon/Sort_Ascending.svg" alt="Sort Asc" />
                    )}
                  </span>
                )}
              </TableSortLabel>
            ) : (
              t(headCell.label)
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const SynchronizePageView = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const listFanpage = useSelector(fanpageFull);
  const dispatch = useDispatch();
  const syncHistoryRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [selectedSystem, setSelectedSystem] = useState({
    icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAq1BMVEX////q9P/a6P7f6/6s0P9ZpP4ukv0BhfsAf/gRhPguivddnffA1/u/3P86mf4Tiv0lfvEfevIAd/NUlfWeyf8nhfUZb+zR4ftqqfu10vyYv/ked/Aace0AXeZ2rvsYbOsxeOsRXuOtxfbI3fwUZecXauoSYOQAVuK0yvZynvGJq/L2+f5Ng+ry9f0AWOMFXOMAUOJRjvOQt/ahuvKNrfCBou5tlewATOEAReAz1JReAAABLklEQVR4AbWPV5bCIBRAH2DvMiM4kZhKsRHs7n9lQ469/HrTc1+F74MwJuizqlRr9Uaz1e68q26v36o3Gs3BkP6QF/fb7zdHFdShg+GQMv5csl4f/7V4J6DD4WQiwsdc0q9PAY8opaUSIorhzrhegw4d0smAMSEYi5L0ntikGfIFA4JwO2eRVNrcO9IRTCk97zALw3iOfca5rxdToKJ9/likHACly0QtzsEigDwK4MpqENoicauLXG8ieZdI2rucMxExuYYznQwAb+PiUtbkgkVRfp5w5xzb8/tAxKtISrVBCB+sShJ7vO8Jh1xKmeehjHyvEr29S5J75fFJSvlbUSzgztZ6Vf73p3enDB7ZaK+8KLEuhWeM1EWZVFgXc3hlsY2tczpfGvgI4Rwj+D7/H5gi8WvJxHMAAAAASUVORK5CYII=",
    label: "Pancake",
    value: "pancake"
  });

  const options = [
    {
      value: "pancake",
      label: "Pancake",
      icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAq1BMVEX////q9P/a6P7f6/6s0P9ZpP4ukv0BhfsAf/gRhPguivddnffA1/u/3P86mf4Tiv0lfvEfevIAd/NUlfWeyf8nhfUZb+zR4ftqqfu10vyYv/ked/Aace0AXeZ2rvsYbOsxeOsRXuOtxfbI3fwUZecXauoSYOQAVuK0yvZynvGJq/L2+f5Ng+ry9f0AWOMFXOMAUOJRjvOQt/ahuvKNrfCBou5tlewATOEAReAz1JReAAABLklEQVR4AbWPV5bCIBRAH2DvMiM4kZhKsRHs7n9lQ469/HrTc1+F74MwJuizqlRr9Uaz1e68q26v36o3Gs3BkP6QF/fb7zdHFdShg+GQMv5csl4f/7V4J6DD4WQiwsdc0q9PAY8opaUSIorhzrhegw4d0smAMSEYi5L0ntikGfIFA4JwO2eRVNrcO9IRTCk97zALw3iOfca5rxdToKJ9/likHACly0QtzsEigDwK4MpqENoicauLXG8ieZdI2rucMxExuYYznQwAb+PiUtbkgkVRfp5w5xzb8/tAxKtISrVBCB+sShJ7vO8Jh1xKmeehjHyvEr29S5J75fFJSvlbUSzgztZ6Vf73p3enDB7ZaK+8KLEuhWeM1EWZVFgXc3hlsY2tczpfGvgI4Rwj+D7/H5gi8WvJxHMAAAAASUVORK5CYII="
    }
  ];

  const dateRange = [
    {
      label: "1",
      value: "LAST_1M",
      range: [
        moment().subtract(1, "months").format("YYYY-MM-DD"), // Ngày trước hôm nay 1 tháng
        moment().format("YYYY-MM-DD") // Ngày hiện tại
      ]
    },
    {
      label: "3",
      value: "LAST_3M",
      range: [
        moment().subtract(3, "months").format("YYYY-MM-DD"), // Ngày trước hôm nay 3 tháng
        moment().format("YYYY-MM-DD") // Ngày hiện tại
      ]
    },
    {
      label: "6",
      value: "LAST_6M",
      range: [
        moment().subtract(6, "months").format("YYYY-MM-DD"), // Ngày trước hôm nay 6 tháng
        moment().format("YYYY-MM-DD") // Ngày hiện tại
      ]
    },
    {
      label: "12",
      value: "LAST_1Y",
      range: [
        moment().subtract(1, "years").format("YYYY-MM-DD"), // Ngày trước hôm nay 1 năm
        moment().format("YYYY-MM-DD") // Ngày hiện tại
      ]
    }
  ];
  const [periodTime, setPeriodTime] = useState({
    label: "3",
    value: "LAST_3M",
    range: [
      moment().subtract(3, "months").format("YYYY-MM-DD"), // Ngày trước hôm nay 3 tháng
      moment().format("YYYY-MM-DD") // Ngày hiện tại
    ]
  });

  const stepAccessTokenHelp = [
    {
      title: t("synchronize_management.access_token_help.title.step1"),
      content: (
        <span>
          {t("synchronize_management.access_token_help.content.step1")}{" "}
          <a
            href="https://pancake.vn/dashboard"
            target="_blank"
            rel="noopener noreferrer"
          >
            Pancake
          </a>
          . {t("synchronize_management.access_token_help.content.step1_suffix")}
        </span>
      ),
      image: t("synchronize_management.access_token_help.img.step1")
    },
    {
      title: t("synchronize_management.access_token_help.title.step2"),
      content: (
        <span>
          {t("synchronize_management.access_token_help.content.step2")}
        </span>
      ),
      image: t("synchronize_management.access_token_help.img.step2")
    },
    {
      title: t("synchronize_management.access_token_help.title.step3"),
      content: (
        <span>
          {t("synchronize_management.access_token_help.content.step3")}
        </span>
      ),
      image: t("synchronize_management.access_token_help.img.step3")
    },
    {
      title: t("synchronize_management.access_token_help.title.step4"),
      content: (
        <span>
          {t("synchronize_management.access_token_help.content.step4")}
        </span>
      ),
      image: t("synchronize_management.access_token_help.img.step4")
    },
    {
      title: t("synchronize_management.access_token_help.title.step5"),
      content: (
        <span>
          {t("synchronize_management.access_token_help.content.step5")}
        </span>
      ),
      image: t("synchronize_management.access_token_help.img.step5")
    },
    {
      title: t("synchronize_management.access_token_help.title.step6"),
      content: (
        <span>
          {t("synchronize_management.access_token_help.content.step6")}
        </span>
      ),
      image: t("synchronize_management.access_token_help.img.step6")
    },
    {
      title: t("synchronize_management.access_token_help.title.step7"),
      content: (
        <span>
          {t("synchronize_management.access_token_help.content.step7")}
        </span>
      ),
      image: t("synchronize_management.access_token_help.img.step7")
    }
  ];

  const [selectedOptions, setSelectedOptions] = useState([]);

  const [startDate, setStartDate] = useState(periodTime.range[0]);
  console.log("🚀 ~ SynchronizePageView ~ startDate:", startDate);
  const [endDate, setEndDate] = useState(periodTime.range[1]);

  const { control, setValue } = useForm({
    defaultValues: {
      date: [null, null]
    }
  });

  const [accessToken, setAccessToken] = useState("");
  const [openAccessTokenHelp, setOpenAccessTokenHelp] = useState(false);
  const [selectedFanPage, setSelectedFanPage] = useState("");
  const [syncHistory, setSyncHistory] = useState([]);

  const [sortOrder, setSortOrder] = useState("desc");

  const [checkboxStates, setCheckboxStates] = useState({
    tag: true,
    email: false,
    phone: false,
    birth: false
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(types.PAGINATION.SIZE);

  const dataCheckGroup = Object.keys(checkboxStates);

  const [showDateRangePicker, setShowDateRangePicker] = useState(false);

  const [data, setData] = useState([]);

  const fetchStatisticData = async () => {
    let searchParts = [];

    if (selectedFanPage) searchParts.push(`pageId==${selectedFanPage.value}`);
    if (selectedSystem) searchParts.push(`system==${selectedSystem.value}`);

    const params = {
      search: searchParts.join(';') 
    };

    try {
      const response = await synchronizeApi.getStatisticSync(params);

      setData(response);
    } catch (error) {
      console.error('Error call API:', error);
    }
  };

  useEffect(() => {
    if (selectedFanPage && selectedSystem) {
      fetchStatisticData(selectedFanPage.value, selectedSystem);
    } else {
      setData([])
    }
  }, [selectedFanPage, selectedSystem]);

  useEffect(() => {
    const params = {
      sort: "name,asc"
    };
    setLoading(true);
    console.log("🚀 ~ useEffect ~ params:", params)
    getFanpage(params)
      .then(() => {})
      .catch((error) => {
        console.error("Error fetching fanpages:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const fanpageOptions = useMemo(() => {
    return listFanpage?.map((fanpage) => ({
      value: fanpage.id,
      label: fanpage.name,
      accesstoken: fanpage.pancakeAccessToken
    }));
  }, [listFanpage]);

  const getFanpage = (params) =>
    dispatch(actionsFanpage.getFanpageFull(params));

  const handleSystemChange = (option) => {
    setSelectedSystem(option);
  };

  const handlePeriodTimeChange = (option) => {
    console.log("==>", option);
    setPeriodTime(option);
    setStartDate(option.range[0]);
    setEndDate(option.range[1]);
    setShowDateRangePicker(false);
  };

  const handleCheckboxChange = (name) => {
    setCheckboxStates((prev) => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  const handleFanPageChange = (event, value) => {
    setSelectedFanPage(value || null);
  
    if (value?.accesstoken) {
      setAccessToken(value.accesstoken);
    } else {
      setAccessToken("");
    }
  };

  const handleSortChange = (columnId) => {
    if (columnId === "sync_time") {
      setSortOrder((prevOrder) => (prevOrder === "desc" ? "asc" : "desc"));
    }
    fetchSyncHistory();
  };

  const fetchSyncHistory = () => {
    if (selectedFanPage) {
      const params = {
        pageId: selectedFanPage.value,
        system: selectedSystem.value,
        page: page,
        size: rowsPerPage,
        sort: `createdAt,${sortOrder}`
      };
      synchronizeApi
        .getHistorySync(params)
        .then((res) => {
          setSyncHistory(res);
          if (res.content.length === 0) {
            setPage(0);
          }
        })
        .catch((error) => {
          console.error("Error fetching sync history:", error);
        });
    }
  };

  useEffect(() => {
    fetchSyncHistory();
  }, [selectedFanPage, page, rowsPerPage, sortOrder]);

  const handleSynchronize = () => {
    console.log("Access Token:", accessToken);

    const paramsForUpdate = {
      pageId: selectedFanPage.value
    };

    const paramsForSync = {
      accessToken: accessToken,
      pageId: selectedFanPage.value
    };

    if (startDate) {
      paramsForSync.fromDate = startDate;
    }
    if (endDate) {
      paramsForSync.toDate = endDate;
    }

    synchronizeApi
      .updatePSIDCustomer(paramsForUpdate)
      .then((res) => {
        console.log("Update PSID Customer successful:", res);
        return synchronizeApi.syncPancakeToBombot(paramsForSync);
      })
      .then((res) => {
        console.log("Synchronization successful:", res);
        fetchSyncHistory();
        dispatch(
          openToast({
            type: "success",
            message: t("synchronize_management.toast.sync_successful")
          })
        );
        if (syncHistoryRef.current) {
          syncHistoryRef.current.scrollIntoView({ behavior: "smooth" });
        }
      })
      .catch((error) => {
        dispatch(
          openToast({
            type: "error",
            message: error?.message
          })
        );
        console.error("Error during synchronization:", error);
      });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChange = (event, value) => {
    setPage(value - 1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleAccessTokenHelp = () => {
    setOpenAccessTokenHelp(!openAccessTokenHelp);
  };

  const handleClearDates = () => {
    const start = moment()
      .subtract(3, "months")
      .startOf("month")
      .format("YYYY-MM-DD");
    const end = moment().endOf("month").format("YYYY-MM-DD");

    setPeriodTime({
      label: "3",
      value: "LAST_3M",
      range: [start, end]
    });

    setStartDate(start);
    setEndDate(end);
    setShowDateRangePicker(false);
    setValue("date", [start, end]);
  };

  const handleShowDateRangePicker = () => {
    setStartDate(moment().subtract(3, "months").format("YYYY-MM-DD"));
    setEndDate(moment().format("YYYY-MM-DD"));
    setShowDateRangePicker(true);
  };

  return (
    // <MainLayout>
      <div className={classes.root}>
        {loading && <Loading />}
        <div className={classes.container}>
          <div>
            <p
              style={{
                color: "#02a351",
                fontSize: "16px",
                fontWeight: 500,
                whiteSpace: "nowrap"
              }}
            >
              {t("synchronize_management.user_sync_info")}
            </p>
          </div>

          <div
            style={{
              // gap: "10px",
              display: "flex",
              width: "100%",
              justifyContent: "center",
              // alignItems: "center"
            }}
          >
            <div
              style={{
                width: "100%",
                // maxWidth: "580px",
                flex: 1
              }}
            >
              <div
                className={classes.syn_info_user}
                style={{ display: "flex" }}
              >
                {/* Cột bên trái */}
                <div style={{ flex: 1 }}>
                  <p className={classes.title}>Fanpage</p>
                  <p className={classes.title}>
                    {t("synchronize_management.system")}
                  </p>
                  <p
                    style={{
                      height: "72px",
                      padding: "8px",
                      marginBottom: "8px"
                    }}
                  >
                    Access Token
                  </p>
                  <p
                    className={classes.title}
                    style={{
                      color: showDateRangePicker ? "gray" : "#000"
                    }}
                  >
                    {t("synchronize_management.time_ago")}
                  </p>
                  <span className={classes.title}>
                    <span>{t("synchronize_management.or")}</span>
                    <button
                      className={classes.buttonSelectPeriodTime}
                      style={{
                        backgroundColor: showDateRangePicker
                          ? "#02a351"
                          : "white",
                        borderColor: showDateRangePicker ? "#02a351" : "#02a351",
                        color: showDateRangePicker ? "white" : "#02a351"
                      }}
                      onClick={handleShowDateRangePicker}
                    >
                      {t("synchronize_management.choose_time")}
                    </button>
                  </span>
                  <p className={classes.title}>
                    {t("synchronize_management.synchronize_data")}
                  </p>
                </div>

                {/* Cột bên phải */}
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      marginBottom: "8px"
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        minWidth: "140px",
                        maxWidth: "380px"
                      }}
                    >
                      {/* <SingleSelectbox
                        options={fanpageOptions}
                        selectedValue={selectedFanPage}
                        onChange={handleFanPageChange}
                        placeholder={t("synchronize_management.choose_fanpage")}
                      /> */}
                      <Autocomplete
                        value={selectedFanPage || null}
                        options={fanpageOptions || []}
                        getOptionLabel={(option) => option.label || ""} 
                        isOptionEqualToValue={(option, value) => option.value === value.value} 
                        onChange={handleFanPageChange}
                        renderInput={(params) => (
                          <TextField {...params} variant="outlined" size="small" placeholder={t("synchronize_management.choose_fanpage")} InputProps={{
                            ...params.InputProps,
                            style: { fontSize: '15px' } 
                          }}/>
                        )}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "8px",
                      width: "100%",
                      maxWidth: "160px"
                    }}
                  >
                    <SingleSelectbox
                      options={options}
                      selectedValue={selectedSystem}
                      onChange={handleSystemChange}
                      placeholder={t("synchronize_management.choose_system")}
                      style={{ minWidth: "135px", maxWidth: "160px" }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "start",
                      marginBottom: "8px"
                    }}
                  >
                    <textarea
                      id="accessToken"
                      value={accessToken}
                      placeholder={t(
                        "synchronize_management.enter_access_token"
                      )}
                      onChange={(e) => setAccessToken(e.target.value)}
                      style={{
                        width: "380px",
                        height: "72px",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        fontSize: "14px",
                        resize: "none"
                      }}
                    />
                    <Tooltip
                      title={t(
                        "synchronize_management.click_to_view_guid_get_access_token"
                      )}
                      arrow
                    >
                      <button
                        className={classes.helpButton}
                        onClick={handleAccessTokenHelp}
                      >
                        <img src="/icon/Circle_Help.svg" alt="Help" />
                      </button>
                    </Tooltip>
                    <CommonModal
                      open={openAccessTokenHelp}
                      setOpen={setOpenAccessTokenHelp}
                      title={t(
                        "synchronize_management.guid_to_get_access_token"
                      )}
                      body={
                        <div>
                          {stepAccessTokenHelp.map((step, index) => (
                            <div key={index} style={{ marginBottom: "16px" }}>
                              <p
                                style={{
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  marginBottom: "8px"
                                }}
                              >
                                {step.content}
                              </p>
                              <div>
                                <img
                                  src={step.image}
                                  alt={step.title}
                                  style={{
                                    height: "auto",
                                    width: "auto",
                                    maxWidth: "562px",
                                    height: "auto",
                                    border: "1px solid #ccc",
                                    borderRadius: "12px"
                                  }}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      }
                      footer={
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center"
                          }}
                        >
                          <ButtonComponent
                            id="closeModalAccessTokenHelp"
                            className={cn(
                              "btn--rounder",
                              "btn--primary--filled"
                            )}
                            title={
                              <Flex align="center">
                                <span>Đã hiểu!</span>
                              </Flex>
                            }
                            backgroundColor="#05AE34"
                            color="white"
                            handleClickButton={() => handleAccessTokenHelp()}
                          />
                        </div>
                      }
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "8px",
                      width: "100%",
                      minWidth: "110px",
                      maxWidth: "120px"
                    }}
                  >
                    <SingleSelectbox
                      options={dateRange}
                      selectedValue={periodTime}
                      onChange={handlePeriodTimeChange}
                      style={{
                        backgroundColor: showDateRangePicker
                          ? "#c2c2c2"
                          : "white",
                        color: showDateRangePicker ? "#c2c2c2" : "#000",
                        border:
                          showDateRangePicker === true && "1px solid #b6b5b5"
                      }}
                      disabled={showDateRangePicker}
                    />
                    <p
                      style={{
                        color: showDateRangePicker ? "gray" : "#000"
                      }}
                    >
                      {t("synchronize_management.month")}
                    </p>
                  </div>
                  {showDateRangePicker ? (
                    <div
                      style={{
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <CustomDateRangePicker
                        control={control}
                        name="date"
                        defaultValue={[startDate, endDate]}
                        title2={
                          <>
                            <img
                              src="./icon/Arrow_Right_SM.svg"
                              style={{
                                paddingLeft: "4px",
                                paddingRight: "4px"
                              }}
                            />
                          </>
                        }
                        onDateChange={(start, end) => {
                          setStartDate(start);
                          setEndDate(end);
                          setValue("date", [start, end]);
                        }}
                      />
                      <button
                        className={classes.clearButton}
                        onClick={handleClearDates}
                      >
                        <img src="/icon/Close_SM.svg" />
                      </button>
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          marginBottom: "8px",
                          height: "42px",
                          width: "100%",
                          backgroundColor: "white"
                        }}
                      ></div>
                    </>
                  )}

                  <div
                    style={{
                      display: "flex",
                      gap: "16px",
                      paddingTop: "20px",
                      marginBottom: "8px"
                    }}
                  >
                    <Tooltip
                      title={t("synchronize_management.only_support_sync_tag")}
                      arrow
                    >
                      <div className={classes.checkboxGroup}>
                        {dataCheckGroup.map((name) => (
                          <Checkbox
                            key={name}
                            id={name}
                            label={t(`synchronize_management.${name}`)}
                            isChecked={checkboxStates[name]}
                            onChange={() => handleCheckboxChange(name)}
                            disabled={name}
                          />
                        ))}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <ButtonComponent
                  id="synchronize"
                  className={cn("btn--rounder", "btn--primary--filled")}
                  title={
                    <Flex align="center">
                      <span>
                        {t("synchronize_management.button.synchronize")}
                      </span>
                    </Flex>
                  }
                  backgroundColor="#05AE34"
                  color="white"
                  handleClickButton={() => handleSynchronize()}
                  disabled={_.isEmpty(selectedFanPage) ? true : false}
                />
              </div>
            </div>

            {/* noi dung chart o day */}
            <div
              style={{
                flex: 1,
                backgroundColor: "white",
                borderLeft: "1px solid #b9b9b938",
              }}
            >
              <SyncChart data={data} selectedFanPage={selectedFanPage} selectedSystem={selectedSystem}/>
            </div>
          </div>

          <div style={{ marginTop: "20px" }}>
            <p style={{ color: "#02a351", fontSize: "16px", fontWeight: 500 }}>
              {t("synchronize_management.sync_history")}
            </p>
          </div>

          <div className={classes.syn_history} ref={syncHistoryRef}>
            {selectedFanPage !== "" ? (
              <>
                {syncHistory && (
                  <>
                    <Paper className={classes.paper} elevation={0}>
                      <TableContainer
                        style={{
                          height:
                            syncHistory?.content?.length > 0 ? "auto" : "52px",
                          maxHeight: "550px",
                          overflowY:
                            syncHistory?.content?.length > 0 ? "auto" : "hidden"
                        }}
                      >
                        <Table
                          stickyHeader
                          className={classes.table}
                          aria-labelledby="tableTitle"
                          aria-label="enhanced table"
                        >
                          <EnhancedTableHead
                            classes={classes}
                            t={t}
                            onSortChange={handleSortChange}
                            sortOrder={sortOrder}
                          />
                          <TableBody>
                            {syncHistory?.content?.map((item, index) => {
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={item.id}
                                >
                                  <TableCell
                                    align="center"
                                    className={classes.witdhOrd}
                                  >
                                    {rowsPerPage * page + index + 1}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.witdhOrd}
                                  >
                                    {new Date(item.createdAt).toLocaleString()}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.witdhOrd}
                                  >
                                    {item.totalCus}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.witdhOrd}
                                  >
                                    {new Date(item.startTime).toLocaleString()}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.witdhOrd}
                                  >
                                    {new Date(item.endTime).toLocaleString()}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.witdhOrd}
                                  >
                                    {item.username}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.witdhOrd}
                                  >
                                    Tag
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.witdhOrd}
                                  >
                                    {new Date(item.endTime).toLocaleString()}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {syncHistory?.content?.length === 0 && (
                        <div
                          style={{
                            fontSize: "14px",
                            height: "100px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            color: "#999"
                          }}
                        >
                          {t("update.no_data")}
                        </div>
                      )}
                    </Paper>
                    {syncHistory?.content?.length > 0 && (
                      <Flex
                        justify="space-between"
                        align="center"
                        className="px-3 py-2"
                      >
                        <TablePagination
                          style={{ margin: "0px 0" }}
                          rowsPerPageOptions={[
                            types.PAGINATION.SIZE,
                            20,
                            30,
                            50
                          ]}
                          count={syncHistory?.totalElements || 0}
                          page={Math.min(
                            page + 1,
                            Math.ceil(
                              syncHistory?.totalElements / rowsPerPage
                            ) || 1
                          )}
                          onPageChange={handleChangePage}
                          // onChangeRowsPerPage={handleChangeRowsPerPage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          className={"pagination"}
                          component="div"
                          rowsPerPage={rowsPerPage}
                          labelRowsPerPage={t("update.display")}
                        />
                        <Pagination
                          style={{ top: 0 }}
                          count={Math.ceil(
                            (syncHistory && syncHistory.totalElements) /
                              rowsPerPage
                          )}
                          page={Math.min(
                            page + 1,
                            Math.ceil(
                              syncHistory?.totalElements / rowsPerPage
                            ) || 1
                          )}
                          onChange={handleChange}
                        />
                      </Flex>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {" "}
                {t(
                  "synchronize_management.select_fanpage_to_view_sync_history"
                )}
              </>
            )}
          </div>
        </div>
      </div>
    // </MainLayout>
  );
};

export default SynchronizePageView;
